import { RootState } from "../../store.types";
import { State } from "./facebook-user.types";

export const getCurrentState = (state: RootState): State => state.facebookUser;
export const getFacebookUser = (state: RootState) => getCurrentState(state).facebookUser;
export const isFacebookUserLoading = (state: RootState) =>
  getCurrentState(state).isFacebookUserLoading;
